// Detectar ambiente automaticamente baseado na URL
const env = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' 
  ? 'development' 
  : 'production'

export default env